import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'

function InventoryItemSuggestion ({ inventoryItemId }) {
  const [suggestion] = useEnvValue(['globals.inventory.order_items', inventoryItemId, 'suggestion'].join('.'), 0)

  return suggestion || '-'
}

export default InventoryItemSuggestion
